import type { FlexContainerProps } from "./flex-container.type";

import { Spin } from "antd";
import { Link } from "react-router";

import "./flex-container.style.less";
import { FlexContainerIconWrapper } from "./flex-container-icon-wrapper";
import { FlexContainerLabel } from "./flex-container-label";

const FlexContainer = ({
  label,
  tooltip,
  value,
  icon,
  link,
  isLoading = false,
  direction = "column",
}: FlexContainerProps) => (
  <Spin spinning={isLoading}>
    <div className="flex-container" style={{ flexDirection: direction }}>
      <FlexContainerLabel label={label} tooltip={tooltip} />
      <FlexContainerIconWrapper icon={icon}>
        {link ? <Link to={link}>{value}</Link> : value}
      </FlexContainerIconWrapper>
    </div>
  </Spin>
);

export default FlexContainer;
